import { FilterOptionKeys, ID } from '@griply/types';
import { getLifeAreaFilterOptions } from '@griply/utils';
import { TFunction } from 'i18next';
import { Heart } from 'shared/assets/icons';
import { FilterOptionType, FilterSelectOption } from 'shared/types/filter';
import { LifeArea } from 'shared/types/life-area';
import { lifeAreaOtherID } from 'shared/types/orderable-section';

export type Options = {
  t: TFunction;
  lifeAreaSorting?: ID[] | null;
};

export const createLifeAreaFilter = (
  lifeAreas: LifeArea[],
  { t, lifeAreaSorting }: Options,
): FilterSelectOption[] => {
  const options = getLifeAreaFilterOptions(lifeAreas, { lifeAreaSorting });

  if (!options.length) {
    return [];
  }

  return [
    {
      id: FilterOptionKeys.LifeArea,
      label: t('general.filters.title.life-area'),
      placeholder: t('general.labels.select'),
      icon: Heart,
      type: FilterOptionType.MultiSelect,
      selectOptions: [
        ...options.map((lifeArea) => ({
          label: lifeArea.name,
          value: lifeArea.id,
        })),
        {
          label: t('general.sections.life-areas.other.title'),
          value: lifeAreaOtherID,
        },
      ],
      canReset: true,
      enableSearch: true,
    },
  ];
};
